export const delegationDisclaimers = {
    PISignatureForExistingDelegation: `Signature requests are automatically generated for any delegations that
        will be under the tenure of the new PI. You can deselect delegations
        that don’t require a new P.I. signature.`,
    AuditNote: {
        hasEndDate: `Setting an end date for this user's Delegation means that they will also
            be automatically removed from the Study Team List on this date.`,
        hasCompletedSignatures: `Modifying data after signature requires a note for the audit log. Also,
            consider if these changes require additional signatures, based on your
            organization's SOP.`,
        noCompletedSignatures: `Modifying data before signature does not require a note for the audit
            log. Also, consider if these changes require additional signatures,
            based on your organization's SOP.`,
        errorMessage: 'An audit note is required for any changes after signatures have been completed.'
    },
    signatures: {
        hasRequiredFields: `Signature requests haven’t been recommended since this delegation
            might not overlap with the PI’s tenure or the PI delegation has not
            been added yet.`,
        hasSignatures: `__signatures__ signature request__plural__ recommended. 
            You can remove or modify this to ensure signature ordering, or if you are unsure of the current delegation details.`
    },
    RoleManagement: {
        isPI: 'If you wait to add your Principal Investigator until the end of your Delegation Log setup, all of their signature requests will go out at the same time.'
    },
    PITenure: {
        overlaps: `This PI can't be added since their tenure conflicts with an existing PI's tenure.
If you want to add this PI, their tenure will need to be modified.`
    },
    DataSource: {
        existingDataSource: `A Data Source with this name already exists. 
Please select that Data Source or give the new Data Source a different name.`
    }
};

